import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { InputSwitch } from 'primereact/inputswitch'
import { Btn, CustomModal } from '../../../../components'
import { errorHandler } from '../../../../services/util/error.service'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import EstoqueHttp from '../../../../services/api/https/estoque/Estoque.http'

const LOAD_MESSAGE = {
  NONE: 'NONE',
  SAVING: 'Salvando configurações de fotografia',
  SUCCESS: 'Configurações de fotografia salvas com sucesso',
}

const INITIAL_STATE = {
  fotografa_estoque: false,
  horario_fotografia: 12,
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

const ModalFotografiaEstoque = ({ estoque, show, onModalClose, onModalSave, dispatch, tpId }) => {
  const [state, setState] = useState({ ...INITIAL_STATE })

  useEffect(() => {
    if (show && estoque) {
      setState(prevState => ({
        ...prevState,
        fotografa_estoque: !!estoque.fotografa_estoque,
          horario_fotografia: estoque.horario_fotografia != null ? estoque.horario_fotografia : 12,
      }))
    }
  }, [show, estoque])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.SAVING:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        save()
        break

      case LOAD_MESSAGE.SUCCESS:
        dispatch(hideLoadingBox())
        dispatch(showMessageBox(state.loadingMessage, null))
        onModalSave(state.savedEstoque)
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      setState(prevState => ({
        ...prevState,
        loadingMessage: LOAD_MESSAGE.NONE,
        errorMessage: null,
      }))
    }
  }, [state.errorMessage])

  const save = () => {
    const horario = Number(state.horario_fotografia)
    if (state.fotografa_estoque && (isNaN(horario) || horario < 0 || horario > 23)) {
      setState(prevState => ({
        ...prevState,
        loadingMessage: LOAD_MESSAGE.NONE,
        errorMessage: 'O horário deve ser um número inteiro entre 0 e 23.',
      }))
      return
    }

    EstoqueHttp.saveFotografiaEstoque(tpId, {
      id: estoque.id,
      fotografa_estoque: state.fotografa_estoque ? 1 : 0,
      horario_fotografia: horario,
    })
      .then(updated =>
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.SUCCESS,
          savedEstoque: updated,
        })),
      )
      .catch(err =>
        setState(prevState => ({
          ...prevState,
          errorMessage: errorHandler(err),
          loadingMessage: LOAD_MESSAGE.NONE,
        })),
      )
  }

  const onBtnSalvarClicked = () => {
    setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.SAVING }))
  }

  const onHorarioChange = value => {
    const num = Number(value)
    if (!isNaN(num)) {
      const clamped = Math.max(0, Math.min(23, num))
      setState(prevState => ({ ...prevState, horario_fotografia: clamped }))
    }
  }

  const labelStyle = { fontSize: '0.8rem', color: '#14B0BF' }

  return (
    <CustomModal
      header="Fotografia Estoque"
      isVisible={show}
      onClose={onModalClose}
      width={450}
    >
      <form className="p-grid" onSubmit={e => e.preventDefault()}>
        <div className="p-col-12" style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 10 }}>
          <InputSwitch
            checked={state.fotografa_estoque}
            onChange={e => setState(prevState => ({ ...prevState, fotografa_estoque: e.value }))}
          />
          <span style={labelStyle}>Fotografar Estoque diariamente?</span>
        </div>

        {state.fotografa_estoque && (
          <div className="p-col-12" style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 10, flexWrap: 'nowrap', whiteSpace: 'nowrap' }}>
            <span style={labelStyle}>Fotografar Estoque diariamente às</span>
            <input
              type="number"
              min={0}
              max={23}
              maxLength={2}
              value={state.horario_fotografia}
              onChange={e => onHorarioChange(e.target.value)}
              style={{
                width: 46,
                height: 26,
                border: '1px solid #F1F1F1',
                outline: 'none',
                textAlign: 'center',
                fontSize: '0.8rem',
                padding: '0 4px',
              }}
            />
            <span style={labelStyle}>horas (Horário de Brasília)</span>
          </div>
        )}

        <div className="p-col-12" style={{ paddingTop: 32, textAlign: 'end' }}>
          <Btn onClick={onBtnSalvarClicked}>Salvar</Btn>
        </div>
      </form>
    </CustomModal>
  )
}

export default connect()(ModalFotografiaEstoque)
